import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DeveloperService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PATH } from '@app/constants';
import { ModalViewProjectsComponent } from '../modal-view-projects/modal-view-projects.component';

@Component({
  selector: 'mnf-modal-view-resources',
  templateUrl: './modal-view-resources.component.html',
  styleUrls: ['./modal-view-resources.component.scss']
})
export class ModalViewResourcesComponent implements OnInit {

  /** ID del solicitante */
  idApplicant: string;
  
  /** ID del proyecto */
  idProject: string;
  
  /** Información del proyecto */
  dev: any;

  amountWithDraw: any;

  /** Variable para el monto disponible a retirar */
  calculateAmount: any;

  /** Variable para la comisión */
  comisionTotal: any;

  /** Variable para el monto neto final */
  amountNetFinal: any;

  /** Variable el IVA */
  ivaTotalF: any;

  /** Variable para la comisión e IVA para Monific */
  toMonific: any;

  /** Variable para obtener la STP del solicitante */
  clabeSTPApplicant: number;

  /** Mensaje a guardar cuando acepte recursos */
  info: string;

  /** Nombre del proyecto */
  nameProject: string;

  /** Variable global para obtener la cantidad de inversiones efectivas realizadas */
  actualInvestmentsMade: number;

  constructor(
    private devServ: DeveloperService, 
    private activeModal: MatDialogRef<ModalViewResourcesComponent>,
    private secActiveModal: MatDialogRef<ModalViewProjectsComponent>,
    private modal: ModalService,
    private toastrServ: ToastrService,
    private router: Router
  ){}

  ngOnInit(): void {
    this.devServ.getInfoDev(this.idProject).subscribe(r => {
      /** Asignar datos a objecto previamente definido */
      this.dev = r?.d;
     
      this.amountWithDraw = this.dev?.amountWithDraw;     

      /** Calcular el monto disponible a retirar */
      this.calculateAmount =  -(this.dev?.amountWithDraw - (this.dev?.participationsTotal - this.dev?.participationsFree) * this.dev?.participationValue);
 
      /** Calcular la comisión */
      this.comisionTotal = this.calculateAmount * this.dev?.commissionWithOutIVA;

      /** Calcular el IVA */
      this.ivaTotalF = (this.comisionTotal * 0.16);

      /** Calcular la comisión e IVA para Monific */
      this.toMonific = this.comisionTotal + this.ivaTotalF;

      /** Calcular el monto neto final */
      this.amountNetFinal = this.calculateAmount - this.comisionTotal - this.ivaTotalF;

      /** Obtener la STP del solicitante */
      this.clabeSTPApplicant = this.dev?.stp?.clabe;

      /** Obtener nombre del proyecto */
      this.nameProject = this.dev?.name;


      /** Obtener la cantidad de inversiones efectivas */
      this.actualInvestmentsMade = this.dev?.actualInvestmentsMade;      

      /** Asignar información de forma automatica
      * @ Aceptación de recursos - Nombre proyecto - Fecha actual
      */
      this.info = `Inversión efectiva (${this.actualInvestmentsMade + 1}): ${this.nameProject}`;

    })

  }

  /** Función para aceptar recursos */
  acceptResources() {
    const n = this.modal.openNIP();
    
    n.beforeClosed().subscribe(nip => {
      if(nip) {
        /** Calcular nuevo monto retirado */
        const sum = this.amountWithDraw + this.calculateAmount;
        this.devServ.updateAmountWithDraw(sum, this.idProject, nip).subscribe(r => {
          this.devServ.saveInfoAcceptedResource(
            this.idProject,
            this.clabeSTPApplicant,
            this.calculateAmount,
            this.ivaTotalF,
            this.comisionTotal,
            this.amountNetFinal,
            this.info,
            this.actualInvestmentsMade + 1
          ).subscribe( r => {
            this.toastrServ.success('Felicidades, haz aceptado los recursos, en breve deberán sumarse al saldo de tu cuenta');
            this.activeModal.close();
            this.secActiveModal.close();
            this.router.navigate(['/desarrollador/mis-movimientos/historial'])
          })
        })        
      } else {
        this.toastrServ.error('Debes ingresar tu MoNip para continuar con está operación');
      }
    })

  }

  /** Función para cerrar Modal */
  closeModal() {
    this.activeModal.close();
  }

}
